var $ = require('../internals/export');
var fromAsync = require('../internals/array-from-async');

// `Array.fromAsync` method
// https://github.com/tc39/proposal-array-from-async
$({ target: 'Array', stat: true, forced: true }, {
  fromAsync: fromAsync
});



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/modules/esnext.array.from-async.js
// module id = 478
// module chunks = 2